import { shipments } from './resources/shipments'
import { orders } from './resources/orders'
import { containers } from './resources/containers'
import { customers } from './resources/customers'
import { users } from './resources/users'
import { publicContainer } from './resources/publicContainer'
import { settings } from './resources/settings'
import { products } from './resources/products'
import { companies } from './resources/companies'
import { certificates } from './resources/certificates'
import { customsDeclarations } from './resources/customsDeclarations'
import { declaredProducts } from './resources/declaredProducts'
import { conditionalItems } from './resources/conditionalItems'
import { audits } from './resources/audits'
import { expenseItems } from './resources/expenseItems'
import { issueVouchers } from './resources/issueVouchers'
import { congNo } from './resources/congNo'
import { tonKho } from './resources/tonKho'
import { thongBao } from './resources/thongBao'
import { giaVon } from './resources/giaVon'
import { nhomHang } from './resources/nhomHang'
import { nhomKhachHang } from './resources/nhomKhachHang'
import { khachHang } from './resources/khachHang'
import { nhaCungCap } from './resources/nhaCungCap'
import { bangGia } from './resources/bangGia'
import { diaChiNhanHang } from './resources/diaChiNhanHang'
import { thongTinXuatHoaDon } from './resources/thongTinXuatHoaDon'
import { phieuNhapKho } from './resources/phieuNhapKho'
import { phieuXuatKho } from './resources/phieuXuatKho'
import { datHang } from './resources/datHang'
import { hoaDon } from './resources/hoaDon'
import { kenhBan } from './resources/kenhBan'
import { datHangNcc } from './resources/datHangNcc'
import { phieuNhanHang } from './resources/phieuNhanHang'
import { traHang } from './resources/traHang'
import { yeuCauSuaChua } from './resources/yeuCauSuaChua'
import { kiemKe } from './resources/kiemKe'
import { danhMucThuKhac } from './resources/danhMucThuKhac'
import { donViTinh } from './resources/donViTinh'
import { thuongHieu } from './resources/thuongHieu'
import { phanLoaiSanPham } from './resources/phanLoaiSanPham'
import { thongTinVatHangHoa } from './resources/thongTinVatHangHoa'
import { thuocTinh } from './resources/thuocTinh'
import { viTri } from './resources/viTri'
import { diaChiLayHang } from './resources/diaChiLayHang'
import { chuyenHang } from './resources/chuyenHang'
import { soQuy } from './resources/soQuy'
import { taiKhoanQuy } from './resources/taiKhoanQuy'
import { mauIn } from './resources/mauIn'
import { yeuCauXuatHoaDon } from './resources/yeuCauXuatHoaDon'
import { baoCao } from './resources/baoCao'
import { vanHanh } from './resources/vanHanh'
import { loTrinh } from './resources/loTrinh'
import { testDataMenuI18n } from '@/modules/test-data/i18n/zh'
import { uiTestMenuI18n } from '@/modules/ui-test/i18n/zh'
import { testModuleChiTietMenuI18n } from '@/modules/test-module-chitiet/i18n/zh'
import { common } from './common'

export const zh = {
  common,
  resources: {
    shipments,
    orders,
    containers,
    customers,
    users,
    publicContainer,
    settings,
    products,
    companies,
    certificates,
    customsDeclarations,
    declaredProducts,
    conditionalItems,
    audits,
    expenseItems,
    issueVouchers,
    congNo,
    tonKho,
    thongBao,
    giaVon,
    nhomHang,
    nhomKhachHang,
    khachHang,
    nhaCungCap,
    bangGia,
    diaChiNhanHang,
    thongTinXuatHoaDon,
    phieuNhapKho,
    phieuXuatKho,
    datHang,
    hoaDon,
    kenhBan,
    datHangNcc,
    phieuNhanHang,
    traHang,
    yeuCauSuaChua,
    kiemKe,
    danhMucThuKhac,
    donViTinh,
    thuongHieu,
    phanLoaiSanPham,
    thongTinVatHangHoa,
    thuocTinh,
    viTri,
    diaChiLayHang,
    chuyenHang,
    soQuy,
    taiKhoanQuy,
    mauIn,
    yeuCauXuatHoaDon,
    baoCao,
    vanHanh,
    loTrinh,
  },
  pages: {
    dashboard: {
      title: '经营概览',
      subtitle: '今天，{date}',
      recentOrders: '最近订单',
      recentInvoices: '最近发票',
      monthLabel: '{year}年{month}月',
      ky: {
        loai: {
          NGAY: '日',
          TUAN: '周',
          THANG: '月',
          QUY: '季',
          NAM: '年',
        },
        ngayLabel: '{year}/{month}/{day}',
        tuanLabel: '{year}年第{tuan}周（{range}）',
        thangLabel: '{year}年{month}月',
        quyLabel: '{year}年第{quy}季度',
        namLabel: '{year}年',
      },
      actions: {
        sell: '销售',
        reports: '报表',
        viewAll: '查看全部',
      },
      kpi: {
        revenue: '营收',
        paid: '已收款',
        invoiceCount: '发票数',
        avgInvoice: '平均每张发票金额',
        vsPrevPeriod: '较上一同期',
        noPrevData: '上一同期（{range}）暂无数据',
        today: '今天：{value}',
        perDay: '日均（有销售日）：{value}',
        unpaid: '待收款：{value}',
        paidRate: '收款率 {value}%',
        prevPeriodHint: '上一同期：{value}',
      },
      chart: {
        title: '每日营收',
        titleOnDay: '当日营收',
        titleInMonth: '本月每日营收',
        titleByMonth: '每月营收',
        revenue: '营收',
        invoiceCount: '发票数',
        dayLabel: '{day}日',
        monthLabel: '{month}月',
        empty: '本期间暂无发票',
      },
      dtBang: {
        nvkdTitle: '营收 × 业务员',
        chiNhanhTitle: '营收 × 门店',
        empty: '本期间暂无营收',
        loadFailed: '无法加载营收表格。',
        tongCong: '合计',
        cols: {
          nvkd: '业务员',
          chiNhanh: '门店',
          sl: '数量',
          dtThuan: '净营收',
          giaVon: '成本',
          loiNhuan: '利润',
          lnTrenVon: '% 加价率',
          margin: '% 毛利率',
          soKg: '公斤',
          soKhoi: '立方',
          tyTrong: '占比',
        },
      },
      topSale: {
        title: '畅销商品',
        empty: '本期间暂无销售商品',
        loadFailed: '无法加载畅销商品。',
        soTopValue: 'Top {n}',
        tieuChi: {
          DOANH_THU: '营收',
          SO_LUONG: '数量',
          LOI_NHUAN: '利润',
        },
        cols: {
          ma: '商品编码',
          ten: '商品名称',
          sl: '数量',
          loiNhuan: '利润',
          lnTrenVon: '% 加价率',
          margin: '% 毛利率',
          soKg: '公斤',
          soKhoi: '立方',
          tyTrong: '份额',
          metric: {
            DOANH_THU: '净营收',
            SO_LUONG: '销量',
            LOI_NHUAN: '利润',
          },
        },
      },
      topMua: {
        title: '客户购买排行',
        empty: '本期间暂无客户购买',
        loadFailed: '无法加载客户购买排行。',
        soTopValue: 'Top {n}',
        tieuChi: {
          DOANH_THU: '营收',
          SO_LUONG: '数量',
          LOI_NHUAN: '利润',
        },
        cols: {
          ma: '客户编码',
          ten: '客户名称',
          nvkd: '负责业务员',
          soHd: '发票数',
          sl: '数量',
          loiNhuan: '利润',
          lnTrenVon: '% 加价率',
          margin: '% 毛利率',
          soKg: '公斤',
          soKhoi: '立方',
          tyTrong: '份额',
          metric: {
            DOANH_THU: '净营收',
            SO_LUONG: '购买量',
            LOI_NHUAN: '利润',
          },
        },
      },
      overview: {
        title: '系统数据',
        subtitle: '当前分店累计数据',
      },
      columns: {
        code: '单号',
        customer: '客户',
        total: '总金额',
        status: '状态',
        time: '时间',
      },
      stats: {
        products: '商品',
        stock: '库存: {count}',
        customers: '客户',
        suppliers: '供应商',
        orders: '订单',
        invoices: '发票',
        returns: '退货',
        goodsReceipts: '进货单',
        stocktakes: '盘点',
        inventoryValue: '库存成本',
      },
      salesReport: {
        title: '销售报告',
        invoiceCount: '发票数',
        revenue: '营收',
        date: '日期',
      },
    },
    pos: {
      title: 'POS收银',
      searchPlaceholder: '搜索商品编码/名称...',
      cart: '购物车',
      items: '件',
      stock: '库存',
      subtotal: '小计',
      checkout: '结账',
      payment: '付款',
      paymentMethod: '支付方式',
      customerPaid: '客户付款',
      change: '找零',
      confirmPay: '确认付款',
      emptyCart: '购物车为空',
      emptyCartHint: '选择商品或扫码',
      checkoutSuccess: '付款成功',
      productNotFound: '未找到商品',
      productInactive: '商品已停售',
      addedToCart: '已添加 {name}',
      invalidPayment: '付款金额无效',
      scanBarcode: '扫描条码',
      scannerError: '无法打开摄像头',
      methods: {
        TIEN_MAT: '现金',
        THE: '卡',
        VI: '电子钱包',
        CHUYEN_KHOAN: '转账',
      },
    },
    profile: {
      title: '我的账户',
      subtitle: '查看和更新个人资料',
      editSection: '编辑信息',
    },
  },
  components: {
    menu: {
      home: '首页',
      productsSection: '产品',
      productMenuCatalog: '目录',
      productMenuSetup: '设置',
      dataSection: '数据',
      products: '产品',
      phanLoaiSanPhamList: '商品分类',
      thongTinVatHangHoaList: '商品增值税信息',
      sanPhamKhaiBao: '申报产品',
      transport: '运输',
      productCategories: '品类',
      priceGroups: '价格',
      declarationGroups: '申报',
      operations: '业务',
      orders: '订单',
      shipments: '运单',
      customers: '客户',
      system: '系统',
      warehouses: '仓库',
      containers: '货柜',
      expenseItems: '费用科目',
      inventory: '库存',
      phieuXuat: '出库单',
      tonKho: '库存',
      congNo: '应收',
      congNoKhachHang: '客户应收',
      congNoThanhToan: '付款',
      congNoHoanTien: '退款',
      congNoTheoDon: '按单据应收',
      congNoTheoDonChiTiet: '按单据明细应收',
      giaVon: '成本',
      staffs: '员工',
      scanner: '扫码',
      settings: '设置',
      companies: '公司',
      certificates: '证书',
      customsDeclarations: '海关申报',
      conditionalItems: '条件',
      auditLogs: '日志',
      branchProject: '分支',
      switchBranch: '切换分支',
      nhomHangList: '商品组',
      partnersSection: '合作伙伴',
      customersSection: '客户',
      nhomKhachHangList: '客户分组',
      khachHangList: '客户',
      diaChiNhanHangList: '配送信息',
      thongTinXuatHoaDonList: '开票信息',
      suppliersSection: '供应商',
      nhaCungCapList: '供应商列表',
      deliverySection: '配送',
      doiTacGiaoHangList: '配送合作伙伴',
      bangGiaList: '价格表设置',
      bangGiaHangHoaList: '商品价格表',
      phieuNhapKhoList: '入库',
      phieuXuatKhoList: '出库',
      dashboard: '概览',
      salesSection: '订单',
      banOnline: '网店销售',
      donHangOnlineList: '网店订单',
      donHangOnlineTiktok: 'TikTok Shop 订单',
      donHangOnlineShopee: 'Shopee 订单',
      hangHoaLienKetList: '商品关联',
      doiSoatOnlineList: '对账',
      gianHangOnlineList: '店铺',
      thietLapKenhOnline: '渠道设置',
      datHangList: '订货',
      hoaDonList: '发票',
      hoaDonChiTietList: '发票明细',
      yeuCauXuatHoaDonList: '开票申请',
      xuatHuyList: '报废出库',
      xuatTraNccList: '退供应商',
      banHang: '销售',
      phanQuyen: '权限',
      muaHang: '采购',
      sanXuat: '生产',
      pos: 'POS收银',
      traHangList: '退货',
      datHangNccList: '供应商订货',
      phieuNhanHangList: '收货单',
      yeuCauSuaChuaList: '维修请求',
      kiemKeList: '盘点',
      auditList: '操作日志',
      logLoiHeThong: '系统错误日志 (DEV)',
      danhMucThuKhacList: '其他费用目录',
      donViTinhList: '计量单位',
      thuongHieuList: '品牌',
      thuocTinhList: '商品属性',
      viTriList: '库位',
      diaChiLayHangList: '取货地址',
      chuyenHangList: '调拨',
      inventorySection: '库存',
      congQuyGroup: '公库',
      soQuyGroup: '现金账',
      soQuyPhieuThu: '收款单',
      soQuyPhieuChi: '付款单',
      soQuyBaoCao: '报表',
      soQuyTaiKhoanQuy: '资金账户管理',
      soQuyLoaiThuChi: '收支类型',
      baoCaoSection: '报表',
      baoCaoBanHangGroup: '销售',
      baoCaoKhoGroup: '仓库',
      baoCaoTongHop: '汇总',
      baoCaoCuoiNgay: '日结',
      baoCaoBanHang: '销售',
      baoCaoDatHang: '订货',
      baoCaoHangHoa: '商品',
      baoCaoKhachHang: '客户',
      baoCaoNhaCungCap: '供应商',
      baoCaoNhanVien: '员工',
      baoCaoKenhBan: '销售渠道',
      baoCaoTaiChinh: '财务',
      baoCaoPhanTich: '分析',
      baoCaoDoanhThuLn: '营收、利润',
      baoCaoTonKho: '库存',
      baoCaoTopSale: '畅销',
      baoCaoTopMua: '客户购买排行',
      baoCaoDaLuu: '已保存报表',
      vanHanhSection: '仓库',
      vanHanhDonHang: '全部订单',
      vanHanhXepNhat: '拣货',
      vanHanhKiemTra: '验货',
      vanHanhDongGoi: '打包',
      vanHanhDieuPhoi: '调度',
      vanHanhGiaoHang: '配送',
      banDoGiaoHang: '配送地图',
      thongBaoTrungTam: '通知中心',
      caiDatThongBao: '通知设置',
      mauInHoaDon: '打印模板',
      uiKit: 'Base UI',
      // ===== impl-b =====
      baoCaoChiTietDonHang: '订单明细报表',
      baoCaoDonVanHanh: '按订单（工作流）',
      ...testDataMenuI18n,
      ...uiTestMenuI18n,
      ...testModuleChiTietMenuI18n,
    },
    phieuTamTonKho: {
      headerLabel: '暂存单',
      headerLabelWithCount: '暂存单 ({count})',
      headerAria: '还有 {count} 张暂存单未完成 — 点击查看列表',
      panelTitle: '还有 {count} 张暂存单未完成',
      panelHint: '请先完成单据以正确扣减库存。点击单号可查看详情。',
      viewAll: '查看全部',
      andMore: '… 以及其他 {count} 张',
      createWarnTitle: '仍有暂存盘点单',
      createWarnBody: '仍有盘点单处于暂存状态。建议先完成（扣减库存）再新建。',
      createWarnTitleChuyenHang: '仍有暂存调拨单',
      createWarnBodyChuyenHang: '仍有调拨单处于暂存状态。建议先完成（扣减库存）再新建。',
      createWarnTitleNhapKho: '仍有暂存入库单',
      createWarnBodyNhapKho: '仍有入库单处于暂存状态。建议先完成（增加库存）再新建。',
      createWarnTitleXuatKho: '仍有暂存出库单',
      createWarnBodyXuatKho: '仍有出库单处于暂存状态。建议先完成（扣减库存）再新建。',
      createWarnContinue: '仍要新建',
      createWarnCodesLabel: '暂存单：',
      inModalCount: '还有 {count} 张',
      chromeHint: '还有 {count} 张暂存单',
      createWarnHeaderHint: '暂存单列表也会一直显示在顶部「暂存单」按钮上 — 请先完成以便正确增减库存。',
    },
  },
  auth: {
    login: '登录',
    logout: '登出',
    register: '注册',
    username: '用户名',
    password: '密码',
    confirmPassword: '确认密码',
    forgotPassword: '忘记密码？',
    resetPassword: '重置密码',
    changePassword: '更改密码',
    email: '电子邮件',
    rememberMe: '记住我',
  },
  navigation: {
    home: '首页',
    orders: '订单',
    shipments: '发货',
    customers: '客户',
    warehouses: '仓库',
    containers: '容器',
    staffs: '员工',
    settings: '设置',
  },
  validation: {
    required: '此字段是必填的',
    email: '无效的电子邮件格式',
    minLength: '最少 {min} 个字符',
    maxLength: '最多 {max} 个字符',
    numeric: '只允许数字',
  },
  messages: {
    success: '成功',
    error: '发生错误',
    warning: '警告',
    info: '信息',
    loading: '加载中...',
    noData: '没有可用数据',
    confirmDelete: '您确定要删除此项吗？',
  },
}
